module.exports = "/packs/images/better-pdf-logo~34e067c4cdac0a90281f914a7e275172.gif";